import styles from './style.module.scss';
import {Box, Typography} from '@mui/material';

type AskLioQueryProps = {
  text: string;
  className?: string;
};

const AurAskLioQuery: React.FC<AskLioQueryProps> = ({text, className}) => {
  return (
    <>
      <Box className={`${styles.aurBoxEnd}`}>
        <Box className={`${className} ${styles.aurBoxQuery}`}>
          <Typography className={`${styles.aurBoxQueryTypography}`}>
            {text}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default AurAskLioQuery;
